<template>
  <t-default-layout active-nav-id="campaigns">
    <div :class="componentClassName">
      <a-back-page :id="id" :text="backPageName()" :page="backPage()" :show="show" />
      <form ref="form" class="t-campaigns-edit__form" enctype="multipart/form-data" @submit.prevent="handleFormSubmit">
        <div class="t-campaigns-edit__fields">
          <m-section>
            <m-action-card :id="idName[0]" title="お知らせコンテンツ登録" header-border no-header-margin icon="clock">
              <div class="t-campaigns-edit__fields__pushtype">
                <m-form-input id="t-campaigns-edit-info-importantFlag__form-input">
                  <a-text id="t-campaigns-edit__fields__a-text-top_1">●</a-text>
                  <a-text id="t-campaigns-edit-info-importantFlag__a-text">PICKUP</a-text>　　
                  <a-switch
                    id="t-campaigns-edit-importantFlag"
                    v-model="campaignData.importantFlag"
                    data-testid="edit-campaign-important-toggle"
                    @change="checkDefaultCategory"
                  />
                </m-form-input>
                <m-form-input id="t-campaigns-edit__fields__pushtype_1">
                  <a-text id="t-campaigns-edit__fields__a-text-top_2">●</a-text>
                  <a-text id="t-campaigns-edit__fields__pushtype__a-text">通知ステータス</a-text>
                  <a-select-field
                    id="t-campaigns-edit__fields__pushtype__a-select-field_1"
                    v-model="pushStatus"
                    :options="pushStatusOptions"
                  />
                  <a-text id="t-campaigns-edit__fields__pushtype__pushDoneCount"
                    >プッシュ通知総回数: {{ campaignData.pushDoneCount }}回</a-text
                  >
                </m-form-input>
              </div>
              <div v-if="pushStatus !== 'none'" class="t-campaigns-edit__fields__pushcategory">
                <m-form-input id="t-campaigns-edit-info-pushcategory__form-input">
                  <a-text id="t-campaigns-edit__fields__pushcategory__a-text-top">●</a-text>
                  <a-text id="t-campaigns-edit__fields__pushcategory__a-text">プッシュ通知カテゴリ</a-text>
                  <div id="t-campaigns-edit__fields__pushcategory__a-apply-text-field">
                    <a-apply-text-field
                      id="t-campaigns-edit__fields__pushcategory__a-apply-text-field-id"
                      v-model="campaignData.pushCategory"
                      data-testid="edit-campaigns-pushcategory"
                      type="text"
                      maxlength="10"
                      placeholder="テキストを入力"
                      maxlength-id="t-campaigns-edit-pushcategory-count"
                    />
                  </div>
                </m-form-input>
              </div>
              <o-push-segment-type 
                v-if="pushStatus === 'limited'" 
                id="campaign-add-segment-type"
                v-model="campaignData.pushSegmentType"
                data-testid="add-campaign-segment-type"
              />

              <o-push-segment-selection
                v-if="pushStatus === 'limited' && campaignData.pushSegmentType === 'selection'"
                id="campaign-add-segment-selection"
                v-model="campaignData.pushSegmentSelectionInfo"
                data-testid="add-campaign-segment-selection"
              />

              <div
                v-if="pushStatus === 'limited' && campaignData.pushSegmentType === 'csv'"
                id="t-campaigns-edit__fields__upload-file"
                class="t-campaigns-edit__fields__upload-file"
              >
                <a-text id="t-campaigns-edit__fields__a-text-top_3">●</a-text>
                <a-text id="t-campaigns-edit__fields__upload-file__a-text">CSVアップロード</a-text>
                <o-csv-uploader
                  v-model:push-target-list-file="campaignData.pushTargetListFile"
                  v-model:push-target-list-file-type="campaignData.pushTargetListFileType"
                  :error-function="showErrorModal"
                />
              </div>
              <div
                v-if="pushStatus === 'limited' && campaignData.pushSegmentType === 'csv'"
                id="t-campaigns-edit__fields__csv-history" class="t-campaigns-edit__fields__csv-history">
                <a-text id="t-campaigns-edit__fields__a-text-top_4">●</a-text>
                <a-text id="t-campaigns-edit__fields__csv-history__a-text">CSVアップロード履歴</a-text>
                <o-csv-history :id="id" type="campaign" :csvlist="pushTargetCsvList" />
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card
              :id="idName[1]"
              test-id-text="edit-campaign"
              title="内容サマリ"
              :document-id="id"
              header-border
              no-header-margin
              icon="clock"
            >
              <div class="t-campaigns-edit__fields">
                <!-- category -->
                <div class="t-campaigns-edit__col-1">
                  <m-form-input id="-campaigns-edit__fields__category">
                    <div class="t-campaigns-edit__category">
                      <o-transition-type-category
                      v-model:transition-id="campaignData.categoryId"
                   />
                    </div>
                  </m-form-input>
                </div>
              <!-- end category -->
                <div id="t-campaigns-edit-uploading-file" class="t-campaigns-edit__row">
                  <div class="t-campaigns-edit__col-1">
                    <div class="t-campaigns-edit__fields">
                      <!-- .jfifと.svg対応はチケット#6297で対応予定 -->
                      <!-- <m-form-input>
                        <a-upload-field
                          id="t-campaigns-edit-upload-image"
                          v-model="campaignData.imageFile.file"
                          name="imageFile"
                          class="t-campaigns-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, .jfif, image/jpg, image/jpeg, .svg"
                          @change="handleUploadFileChangeImg('imageFile', campaignData.imageFile.file)"
                          @showErrorModal="showErrorModal"
                        />
                      </m-form-input> -->
                      <m-form-input>
                        <a-upload-field
                          id="t-campaigns-edit-upload-image"
                          v-model="campaignData.imageFile.file"
                          test-id-text="edit-campaign-summary-image"
                          name="imageFile"
                          class="t-campaigns-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChangeImg('imageFile', campaignData.imageFile.file)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-campaigns-edit__col-2">
                    <div class="t-campaigns-edit__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="campaignData.title"
                          data-testid="edit-campaign-summary-title-input"
                          type="text"
                          maxlength="16"
                          placeholder="タイトル入力"
                          maxlength-id="add-campaign-edit-title-maxlength"
                        />
                      </m-form-input>
                      <m-form-input>
                        <a-apply-text-field
                          v-model="campaignData.text"
                          data-testid="edit-campaign-summary-content-input"
                          class="t-campaigns-edit__content-input"
                          type="textarea"
                          rows="2"
                          maxlength="35"
                          placeholder="テキスト入力"
                          maxlength-id="add-campaign-edit-text-maxlength"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[2]" title="詳細ページ内容" header-border no-header-margin icon="clock-remove">
              <div class="t-campaigns-edit__fields">
                <div id="t-campaigns-edit-info-uploading-file" class="t-campaigns-edit__row">
                  <div class="t-campaigns-edit__col-1">
                    <div class="t-campaigns-edit__fields">
                      <!-- .jfifと.svg対応はチケット#6297で対応予定 -->
                      <!-- <m-form-input>
                        <a-upload-field
                          id="t-campaigns-edit-info-upload-image"
                          v-model="campaignData.detailInfo.imageFile.file"
                          class="t-campaigns-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, .jfif, image/jpg, image/jpeg, .svg"
                          @change="handleUploadFileChangeImg(campaignData.detailInfo.imageFile)"
                          @showErrorModal="showErrorModal"
                        />
                      </m-form-input> -->
                      <m-form-input>
                        <a-upload-field
                          id="t-campaigns-edit-info-upload-image"
                          v-model="campaignData.detailInfo.imageFile.file"
                          test-id-text="edit-campaign-detail-image"
                          class="t-campaigns-edit-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChangeImg('detailImageURL', campaignData.detailInfo.imageFile.file)"
                          @show-error-modal="showErrorModal"
                        />
                      </m-form-input>
                    </div>
                  </div>
                  <div class="t-campaigns-edit__col-2">
                    <div class="t-campaigns-edit__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="t-campaigns-edit-info-title"
                          v-model="campaignData.detailInfo.title"
                          data-testid="edit-campaign-detail-title-input"
                          type="text"
                          maxlength="50"
                          placeholder="タイトル入力"
                          maxlength-id="add-campaign-edit-info-text-maxlength"
                        />
                      </m-form-input>
                      <m-rich-text-editor
                        id="htmlContent"
                        :html-content="campaignData.detailInfo.htmlContent"
                        max-length="800"
                        @get-html-content="campaignData.detailInfo.htmlContent = $event"
                        @get-text="campaignData.detailInfo.text = $event"
                      />
                    </div>
                  </div>
                </div>
                <o-transition-type-service
                  v-if="updatedDataFlag"
                  v-model:transition-type="campaignData.detailInfo.transitionType"
                  v-model:transition-doc="campaignData.detailInfo.transitionDoc"
                  v-model:contents-url="campaignData.detailInfo.contentsURL"
                />
                <div v-if="campaignData.detailInfo.transitionType === 'url'" class="t-campaigns-edit__fields">
                  <m-form-input id="t-campaigns-edit-info-webviewFlag__form-input">
                    <a-text id="t-campaigns-edit-info-webviewFlag__a-text">Webビュー</a-text>　　
                    <a-switch
                      id="t-campaigns-edit-webviewFlag"
                      v-model="campaignData.detailInfo.webviewFlag"
                      data-testid="add-campaigns-detail-webview-toggle-button"
                    />
                    <a-text id="t-campaigns-edit-info-webview-note__a-text"
                      >※Webビュー設定ONの場合、URLにはダイナミックリンクを登録しないでください。</a-text
                    >
                  </m-form-input>
                </div>
                <div v-if="campaignData.detailInfo.transitionType === 'url'" class="t-campaigns-add__fields">
                  <m-form-input id="t-campaigns-edit-info-dAccountLoginFlag__form-input">
                    <a-text id="t-campaigns-edit-info-dAccountLoginFlag__a-text">ビジネスｄアカウントログイン</a-text>
                    <a-switch
                      id="t-campaigns-add-dAccountLoginFlag"
                      v-model="campaignData.detailInfo.dAccountLoginFlag"
                      data-testid="add-campaigns-detail-webview-toggle-button"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-campaigns-edit__fields">
                <div id="t-campaigns-edit-cast-start-date-day__row" class="t-campaigns-edit__row">
                  <a-text id="t-campaigns-edit-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-campaigns-edit-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="campaignData.castStartDate"
                      test-id-text="edit-campaign-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="hasParentDoc"
                    />
                  </m-form-input>
                </div>
                <div class="t-campaigns-edit__row">
                  <a-text id="t-campaigns-edit-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-campaigns-edit-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="campaignData.castEndDate"
                      test-id-text="edit-campaign-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-campaigns-edit__fields__pushtype">
                <m-form-input id="t-campaigns-edit__fields__pushtype_2">
                  <a-select-field
                    id="t-campaigns-edit__fields__pushtype__a-select-field_2"
                    v-model="campaignData.checkStatus"
                    data-testid="edit-campaign-check-status-select"
                    :options="checkStatusOptions"
                    :v-options="visibleCheckStatusOptions"
                  />
                </m-form-input>
              </div>
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="campaignData.checkHistories"
                id-text="campaign-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button id="saveBtn" data-testid="edit-campaign-save-button" variant="block" color="primary" submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="campaignsCreate_resultModal"
        :visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="campaignsCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import OModal from '@/components/organisms/modal';
import OCsvUploader from '@/components/organisms/csv-uploader/index.vue';
import OCsvHistory from '@/components/organisms/csv-history/index.vue';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import OTransitionTypeService from '@/components/organisms/transition-type-service';
import OTransitionTypeCategory from '@/components/organisms/transition-type-category';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { useVuelidate } from '@vuelidate/core';
import { campaignValidation } from '@/validations/campaign.js';
import { cloneDeep } from 'lodash';
import dayjs from 'dayjs';
import MRichTextEditor from '@/components/molecules/rich-text-editor';
import OPushSegmentType from '@/components/organisms/push-segment-type';
import OPushSegmentSelection from '@/components/organisms/push-segment-selection';
import { buildPushSegmentSelectionForDisplay, buildPushSegmentSelectionForSave } from '@/common/pushSegmentConvert';

export default {
  name: 't-campaigns-edit',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    OCsvUploader,
    OCsvHistory,
    MDataTable,
    ADataTableColumn,
    MFormInput,
    ASelectField,
    OModal,
    MFormActionButtons,
    ASwitch,
    AUploadField,
    ACalendarField,
    AApplyTextField,
    MRichTextEditor,
    OTransitionTypeService,
    OTransitionTypeCategory,
    OPushSegmentType,
    OPushSegmentSelection
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      id: this.$route.query.id,
      source: this.$route.query.source,
      show: this.$route.query.show ?? '1',
      idName: [],
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      hasParentDoc: false,
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      //NEWSデータ
      campaignData: {
        categoryId: '', // カテゴリID
        pushFlag: false, //push 通知フラグ
        text: '', //NEWS内容
        title: '', //NEWSタイトル
        imageURL: '', //
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        importantFlag: false, //優先フラグ
        castStartDate: '', //公開開始日
        castEndDate: '', //公開終了日
        deleteDate: '', //削除予定日
        draftFlag: false, //下書き
        checkStatus: 'draft', //チェックステータス
        pushDoneCount: 0, //プッシュ通知総回数
        detailInfo: {
          //NEWS詳細
          text: '',
          title: '',
          htmlContent: '',
          contentsURL: '',
          webviewFlag: false, //Webビューフラグ
          contentsFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          imageURL: '',
          imageFile: {
            file: null,
            filename: null,
            binary: null,
            size: null,
          },
          transitionType: 'url', //遷移先種別
          transitionDoc: '', //遷移先ドキュメントID
          dAccountLoginFlag: false, //ビジネスｄアカウントログイン
        },
        pushType: 'ALL',
        pushTargetListFileType: 'accountid',
        pushTargetListFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
        pushCategory: '',
        pushSegmentType: 'selection',
        pushSegmentSelectionInfo: {
          loginFlag: true,
          accountTypes: [],
          industries: [],
          employeeCounts: [],
        }
      },

      // CSVデータ
      pushTargetCsvList: [],

      isPublished: false, //公開中かどうかのフラグ
      beforeCastEndDate: '', //変更前の公開終了日時
      pushProcessStatus: 'completed', //completedの場合、通知済み。pendingの場合、通知実施対象になる。processingの場合、通知準備中
      currentCheckStatus: 'draft', //DBに現在のcheckStatus
      pushStatus: 'all',
      pushStatusOptions: [
        { value: 'all', label: '全体プッシュ通知' },
        { value: 'limited', label: '特定プッシュ通知' },
        { value: 'none', label: 'プッシュ通知なし' },
      ],
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      visibleCheckStatusOptions: [],
      updatedDataFlag: false,
    };
  },

  validations() {
    return campaignValidation.update(this.campaignData.checkStatus, this.campaignData.detailInfo.transitionType);
  },

  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-campaigns-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-campaigns-edit-' + i;
    }
    this.handleGetCampaignInfo();
  },
  mounted() {},
  methods: {
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.campaignData);
      const htmlContent = payload.detailInfo.htmlContent;
      const hasContentError = messageContent.validateHtmlContentUrls(htmlContent, this.showErrorModal,messageContent.urlSpecialCharater);
      if (hasContentError) {
        return;
      }
      // URLに特殊文字　<>'"　を入力するチェックする
      if (messageContent.checkUrlSpecialCharacter(payload.detailInfo.contentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      payload.detailInfo.contentsURL = encodeURI(payload.detailInfo.contentsURL);
      // Note: 「=」はCloudArmorポリシーに抵触するケースがあるためエスケープを行う
      payload.title = payload.title.replace(/=/g, '%%eq%%');
      payload.text = payload.text.replace(/=/g, '%%eq%%');
      payload.detailInfo.title = payload.detailInfo.title.replace(/=/g, '%%eq%%');
      payload.detailInfo.text = payload.detailInfo.text.replace(/=/g, '%%eq%%');

      // Note: htmlコンテンツは不要なタグの削除
      payload.detailInfo.htmlContent = utils.processHtmlContent(payload.detailInfo.htmlContent);

      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      const id = this.$route.query.id;
      if (id) {
        if (this.campaignData.castEndDate) {
          const castEndDate = new Date(this.campaignData.castEndDate);
          const deleteDate = new Date(castEndDate.setFullYear(castEndDate.getFullYear() + 1));
          this.deleteDate = this.convertDateToString(deleteDate);
        }

        // 特定プッシュ通知以外はファイルクリア
        if (this.pushStatus !== 'limited') {
          this.campaignData.pushTargetListFile.filename = null;
          this.campaignData.pushTargetListFile.binary = null;
          this.campaignData.pushTargetListFile.size = null;
        }

        // 通知ステータスの状態を反映
        switch (this.pushStatus) {
          case 'all': {
            this.campaignData.pushFlag = true;
            this.campaignData.pushType = 'ALL';
            break;
          }
          case 'limited': {
            this.campaignData.pushFlag = true;
            this.campaignData.pushType = 'Limited';
            break;
          }
          case 'none': {
            this.campaignData.pushFlag = false;
            this.campaignData.pushType = 'ALL';
            break;
          }
          default: {
            this.campaignData.pushFlag = false;
            this.campaignData.pushType = 'ALL';
          }
        }
        // pushFlagをONの場合、通知実施対象の投稿にする
        if (this.campaignData.pushFlag) {
          this.pushProcessStatus = 'pending';
        }
        const formDataTmp = {
          id: id,
          text: payload.text ?? '',
          title: payload.title ?? '',
          categoryId: this.campaignData.categoryId ?? '',
          imageFile: this.campaignData.imageFile.binary ?? '',
          pushFlag: this.campaignData.pushFlag ?? false,
          importantFlag: this.campaignData.importantFlag ?? false,
          castStartDate: this.campaignData.castStartDate ?? '',
          castEndDate: this.campaignData.castEndDate ?? '',
          deleteDate: this.deleteDate ?? '',
          draftFlag: this.campaignData.draftFlag ?? false,
          checkStatus: this.campaignData.checkStatus ?? 'draft',
          userList: '',
          imageURL: this.campaignData.imageURL ?? '',
          detailInfo: {
            text: payload.detailInfo.text ?? '',
            title: payload.detailInfo.title ?? '',
            htmlContent: payload.detailInfo.htmlContent ?? '',
            imageFile: this.campaignData.detailInfo.imageFile.binary ?? '',
            imageURL: this.campaignData.detailInfo.imageURL ?? '',
            contentsURL: encodeURI(this.campaignData.detailInfo.contentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
            webviewFlag: this.campaignData.detailInfo.webviewFlag ?? false,
            transitionType: this.campaignData.detailInfo.transitionType ?? 'url',
            transitionDoc: this.campaignData.detailInfo.transitionDoc ?? '',
            dAccountLoginFlag: this.campaignData.detailInfo.dAccountLoginFlag ?? false,
          },
          pushType: this.campaignData.pushType ?? 'ALL',
          pushTargetListFile: this.campaignData.pushTargetListFile.binary ?? '',
          pushTargetListFileSize: this.campaignData.pushTargetListFile.size ?? 0,
          pushTargetListFileName: this.campaignData.pushTargetListFile.filename ?? '',
          pushTargetListFileType: this.campaignData.pushTargetListFileType ?? 'accountid',
          checkHistories: this.campaignData.checkHistories ?? [],
          pushCategory: this.campaignData.pushCategory ?? '',
          pushSegmentType: this.campaignData?.pushSegmentType ?? 'selection',
          pushSegmentSelectionInfo: buildPushSegmentSelectionForSave(this.pushStatus, this.campaignData),
          pushProcessStatus: this.pushProcessStatus ?? 'pending',
          retryCount: 0,
        };
        await this.postRequest('/campaigns/edit', formDataTmp).then(res => {
          if (res.status === 'success') {
            this.$router.push({ name: 'Campaigns', query: { show: this.show } });
          } else {
            if (res.message) {
              this.showErrorModal(res.message);
            } else {
              this.showErrorModal(messageContent.requireTry('NEWS更新'));
            }
          }
        });
      } else {
        this.showErrorModal(messageContent.requireTry('NEWS更新'));
      }
    },
    handleUploadFileChangeImg(type, file) {
      const vm = this;
      const reader = new FileReader();
      const data = type === 'imageFile' ? vm.campaignData.imageFile : vm.campaignData.detailInfo.imageFile;
      reader.addEventListener(
        'load',
        function () {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          data.binary = content;
        },
        false
      );

      if (file[0]) {
        reader.readAsDataURL(file[0]);
        data.filename = file[0].name;
        data.size = file[0].size;
        vm.agree = true;
      } else {
        // Clear file content
        data.file = null;
        data.filename = null;
        data.binary = null;
        data.size = null;
        vm.agree = false;
        type === 'imageFile' ? (vm.campaignData.imageURL = '') : (vm.campaignData.detailInfo.imageURL = '');
      }
    },
    handleGetCampaignInfo() {
      const nowDate = utils.currentDateTime();
      const id = this.$route.query.id;
      if (id) {
        this.postRequest('/campaigns/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data && e.data.data) {
              const data = e.data.data;
              const authInfo = this.$store.state.user.authInfo;
              if ((authInfo === 'writer' && data.checkStatus === 'draft') || authInfo !== 'writer') {
                this.campaignData.categoryId = data?.categoryId || '',
                this.campaignData.pushFlag = data?.pushFlag || false;
                this.campaignData.title = data?.title || '';
                this.campaignData.text = data?.text || '';
                this.campaignData.imageURL = data?.imageURL || '';
                (this.campaignData.imageFile = {
                  file: data.imageURL ? data.imageURL : null,
                }),
                  (this.campaignData.importantFlag = data?.importantFlag || false);
                this.campaignData.castStartDate = data?.castStartDate || '';
                this.campaignData.castEndDate = data?.castEndDate || '';
                this.campaignData.detailInfo.title = data?.detailInfo?.title || '';
                this.campaignData.detailInfo.text = data?.detailInfo?.text || '';
                this.campaignData.detailInfo.transitionType = data?.detailInfo?.transitionType || 'url';
                this.campaignData.detailInfo.transitionDoc = data?.detailInfo?.transitionDoc || '';
                if (data.detailInfo?.htmlContent) {
                  this.campaignData.detailInfo.htmlContent = data?.detailInfo?.htmlContent;
                } else {
                  // Note: 改行をpタグに統一してhtml化
                  this.campaignData.detailInfo.htmlContent =
                    '<p>' + this.campaignData.detailInfo.text.replace(/\n/g, '</p><p>') + '</p>';
                }
                this.campaignData.detailInfo.contentsURL = decodeURI(data?.detailInfo?.contentsURL) || '';
                this.campaignData.detailInfo.webviewFlag = data?.detailInfo?.webviewFlag || false;
                this.campaignData.detailInfo.dAccountLoginFlag = data?.detailInfo?.dAccountLoginFlag || false;
                this.campaignData.detailInfo.imageURL = data?.detailInfo?.imageURL || '';
                if (data?.pushDoneCount) {
                  this.campaignData.pushDoneCount = data?.pushDoneCount;
                }
                (this.campaignData.detailInfo.imageFile = {
                  file: data.detailInfo?.imageURL ? data.detailInfo.imageURL : null,
                }),
                  (this.dataLoaded = true);
                // 変更前の公開終了日時を保存
                this.beforeCastEndDate = data?.castEndDate || '';
                // 公開中の投稿か確認
                if (
                  data &&
                  data.checkStatus === 'approved' &&
                  data.castStartDate &&
                  data.castEndDate &&
                  data.castStartDate <= nowDate &&
                  nowDate <= data.castEndDate
                ) {
                  this.isPublished = true;
                  this.minDate = '';
                }

                if (this.isPublished) {
                  this.$router.push({ name: 'Campaigns' });
                  return;
                }

                this.hasParentDoc = data?.parentDocId ? true : false;

                // DBに現在のcheckStatusを保存
                this.currentCheckStatus = data?.checkStatus;

                this.campaignData.pushType = data?.pushType || 'ALL';

                // 通知ステータス設定
                if (this.campaignData.pushFlag === false) this.pushStatus = 'none';
                else if (this.campaignData.pushType === 'ALL') this.pushStatus = 'all';
                else this.pushStatus = 'limited';

                this.campaignData.pushCategory = data?.pushCategory || '';

                this.campaignData.pushSegmentType = data.pushSegmentType || 'selection';
                this.campaignData.pushSegmentSelectionInfo = buildPushSegmentSelectionForDisplay(this.pushStatus, data);

                // CSVアップロード履歴
                if (e.data.pushTargetCsv) {
                  this.pushTargetCsvList = Object.entries(e.data.pushTargetCsv).map(([key, value]) => {
                    value['id'] = key;
                    return value;
                  });
                  // テスト特定配信用のCSVを反映させない
                  this.pushTargetCsvList = this.pushTargetCsvList.filter(csv => !csv.testPushFlag);
                  this.pushTargetCsvList.sort((a, b) => dayjs(b.updateDate).valueOf() - dayjs(a.updateDate).valueOf());
                }

                // 現在のcheckStatusの値しだいでvisibleCheckStatusOptionsを変更する
                this.visibleCheckStatusOptions = this.selectVisibleCheckStatusOptions(data?.checkStatus || '');
                // DBから取得したcheckHistoriesが空配列のときは更新せず、初期値のcampaignData.checkHistoriesを用いる
                if (data?.checkHistories && data?.checkHistories.length > 0) {
                  this.campaignData.checkHistories = data?.checkHistories;
                }
              } else {
                this.$router.push({ name: 'PermissionDenied' });
                return;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('NEWS取得'));
            }
            this.updatedDataFlag = true;
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('NEWS取得'));
          });
      }
    },
    handleCancelClick() {
      const id = this.id;
      const source = this.source;
      if (id && source === 'detail') {
        return this.$router.push({ name: 'CampaignsDetail', query: { id: id, show: this.show } });
      } else {
        return this.$router.push({ name: 'Campaigns', query: { show: this.show } });
      }
    },
    selectVisibleCheckStatusOptions(checkStatus) {
      if (checkStatus === 'draft') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'checked', label: 'チェック済み' },
        ];
      } else if (checkStatus === 'checked') {
        return [
          { value: 'draft', label: '下書き' },
          { value: 'approved', label: '承認済み' },
        ];
      } else if (checkStatus === 'approved') {
        return [{ value: 'draft', label: '下書き' }];
      }
      // イレギュラーは下書き相当
      return [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
      ];
    },
    backPageName() {
      const source = this.source;
      if (source === 'detail') {
        return '詳細画面';
      } else {
        return '一覧画面';
      }
    },
    backPage() {
      const source = this.source;
      if (source === 'detail') {
        return 'CampaignsDetail';
      } else {
        return 'Campaigns';
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    checkDefaultCategory() {
      if (this.campaignData.importantFlag && this.campaignData.pushCategory === 'NEWS') {
        this.campaignData.pushCategory = 'PICKUP';
      } else if (!this.campaignData.importantFlag && this.campaignData.pushCategory === 'PICKUP') {
        this.campaignData.pushCategory = 'NEWS';
      }
    },
  },
};
</script>
